import { FEATURE_FLAGS } from '@constants/feature';

import { getPermissionCatalogEntry } from './permissionCatalog';

export type CreateRoleFeatureContext = {
  orgFeatureFlags?: string[];
  isAttendanceFeatureEnabled?: boolean;
};

const MODULE_FEATURE_FLAGS: Partial<Record<string, string>> = {
  Events: FEATURE_FLAGS.EVENTS,
  Forms: FEATURE_FLAGS.FORMS,
  'Lead management': FEATURE_FLAGS.LEAD_MANAGEMENT,
  'Expense tracker': FEATURE_FLAGS.EXPENSE_TRACKER,
  Integrations: FEATURE_FLAGS.API_INTEGRATIONS
};

export const isPermissionModuleFeatureEnabled = (
  module: string,
  context: CreateRoleFeatureContext
): boolean => {
  if (module === 'Attendance') {
    return Boolean(context.isAttendanceFeatureEnabled);
  }

  const featureFlag = MODULE_FEATURE_FLAGS[module];
  if (!featureFlag) return true;

  return context.orgFeatureFlags?.includes(featureFlag) ?? false;
};

export const isPermissionSlugFeatureEnabled = (
  slug: string,
  context: CreateRoleFeatureContext
): boolean => {
  const { module } = getPermissionCatalogEntry(slug);
  return isPermissionModuleFeatureEnabled(module, context);
};

export const filterDisplayablePermissionSlugs = (
  slugs: string[],
  context: CreateRoleFeatureContext
): string[] =>
  slugs.filter((slug) => isPermissionSlugFeatureEnabled(slug, context));
